export const SLIDER_SIZES = {
  299: 1.2,
  300: 1.21,
  301: 1.22,
  302: 1.22,
  303: 1.22,
  304: 1.225,
  305: 1.227,
  306: 1.229,
  307: 1.235,
  308: 1.24,
  309: 1.25,
  310: 1.25,
  311: 1.255,
  312: 1.258,
  313: 1.26,
  314: 1.26,
  315: 1.265,
  316: 1.27,
  317: 1.275,
  318: 1.28,
  319: 1.28,
  320: 1.29,
  321: 1.29,
  322: 1.29,
  323: 1.292,
  324: 1.295,
  325: 1.295,
  326: 1.3,
  327: 1.31,
  328: 1.32,
  329: 1.32,
  330: 1.33,
  331: 1.33,
  332: 1.335,
  333: 1.335,
  334: 1.335,
  335: 1.335,
  336: 1.34,
  337: 1.35,
  338: 1.35,
  339: 1.355,
  340: 1.36,
  341: 1.36,
  342: 1.37,
  343: 1.375,
  344: 1.38,
  345: 1.38,
  346: 1.385,
  347: 1.385,
  348: 1.39,
  349: 1.39,
  350: 1.4,
  351: 1.41,
  352: 1.41,
  353: 1.42,
  354: 1.42,
  355: 1.42,
  356: 1.425,
  357: 1.425,
  358: 1.425,
  359: 1.425,
  360: 1.43,
  361: 1.435,
  362: 1.435,
  363: 1.44,
  364: 1.45,
  365: 1.46,
  366: 1.47,
  367: 1.47,
  368: 1.47,
  369: 1.48,
  370: 1.48,
  371: 1.48,
  372: 1.48,
  373: 1.49,
  374: 1.49,
  375: 1.5,
  376: 1.5,
  377: 1.5,
  378: 1.5,
  379: 1.53,
  380: 1.53,
  381: 1.53,
  382: 1.54,
  383: 1.54,
  384: 1.55,
  385: 1.55,
  386: 1.55,
  387: 1.56,
  388: 1.56,
  389: 1.56,
  390: 1.57,
  391: 1.57,
  392: 1.57,
  393: 1.57,
  394: 1.58,
  395: 1.58,
  396: 1.58,
  397: 1.58,
  398: 1.59,
  399: 1.59,
  400: 1.59,
  401: 1.59,
  402: 1.59,
  403: 1.6,
  404: 1.6,
  405: 1.62,
  406: 1.62,
  407: 1.62,
  408: 1.63,
  409: 1.63,
  410: 1.63,
  411: 1.63,
  412: 1.63,
  413: 1.63,
  414: 1.64,
  415: 1.64,
  416: 1.64,
  417: 1.65,
  418: 1.65,
  419: 1.65,
  420: 1.65,
  421: 1.66,
  422: 1.66,
  423: 1.66,
  424: 1.67,
  425: 1.68,
  426: 1.68,
  427: 1.68,
  428: 1.68,
  429: 1.69,
  430: 1.7,
  431: 1.7,
  432: 1.7,
  433: 1.7,
  434: 1.71,
  435: 1.71,
  436: 1.71,
  437: 1.72,
  438: 1.72,
  439: 1.72,
  440: 1.73,
  441: 1.73,
  442: 1.74,
  443: 1.74,
  444: 1.75,
  445: 1.75,
  446: 1.76,
  447: 1.76,
  448: 1.77,
  449: 1.77,
  450: 1.78,
  451: 1.78,
  452: 1.79,
  453: 1.79,
  454: 1.8,
  455: 1.8,
  456: 1.81,
  457: 1.81,
  458: 1.82,
  459: 1.82,
  460: 1.83,
  461: 1.83,
  462: 1.84,
  463: 1.84,
  464: 1.85,
  465: 1.85,
  466: 1.86,
  467: 1.86,
  468: 1.87,
  469: 1.87,
  470: 1.88,
  471: 1.88,
  472: 1.89,
  473: 1.89,
  474: 1.9,
  475: 1.9,
};
